import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { DxButtonModule, DxTextBoxModule, DxPopupModule, DxScrollViewModule } from 'devextreme-angular';
import { CtlTemDonemAramaComponent } from './ctl-tem-donem-arama/ctl-tem-donem-arama.component';
import { TemDonemService } from './ctl-tem-donem.service';
import { CommonModule } from '@angular/common';
import { CtlSablonComponent } from '../ctl-sablon/ctl-sablon.component';
import { LabelMode } from 'devextreme/common';
import { UtilsService } from '../../../services/utils.service';
import { OrtakService } from '../../../services/ortak.service';

@Component({
  selector: 'dk-ctl-tem-donem',
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlTemDonemAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    CtlSablonComponent,
  ],
  providers: [TemDonemService],
  templateUrl: './ctl-tem-donem.component.html',
  styleUrls: ['./ctl-tem-donem.component.scss'],
})
export class CtlTemDonemComponent {
  public crudPopupVisible = false;
  public title!: string;
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  @Input() labelText = "";
  @Input() labelMode:LabelMode = null;public isFirst = true;
  public control!: any;
  controlName = "TemDonem";
  public data: any;
  @Input() code: any;
  @Input() warningMessage: string | null = null;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: TemDonemService, private utilsService: UtilsService, private ortakService: OrtakService) {}

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
            this.service.setParams(this.isReadOnly,this.isBindCheck)
  }
      ngOnChanges(changes: SimpleChanges) {
        if (changes['isReadOnly'] || changes['isBindCheck']) {
            this.service.setParams(this.isReadOnly,this.isBindCheck)
          }
      }
  getControl(){
    this.ortakService.getControl(this.controlName)
    .subscribe((data) => {
      this.control = data?.controlMetadata;
             //this.service.getDlist(this.control?.dlistCode);
      this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
      //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if(data?.controlMetadata.dlistMetadata.baseEntity){
          if(this.labelText === "")this.labelText = this.control.controlDescription;
          if(this.code && this.control) this.getData(this.code,true)
if(this.isFirst) this.isFirst = false;;
        }
    });
  }


  searchClick() {
    if(this.isReadOnly) return;
    this.crudPopupVisible = true
  }

  clear() {
    if(this.isReadOnly) return;
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }

  handleValueChange(e: any) {
    if (e === '' || e === null) this.clear();
    else if(!this.isFirst) this.getData(e);
    this.isFirst = false;
  }

  getData(code: any, isSetData?: boolean) {

    this.data = this.service.getData(Number(code),this.control,this.control.dlistMetadata.baseEntity,isSetData);
    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0].Donem;
        this.code = result[0].Donem;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }
    });

  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.code = result.data.Donem;
      this.dataResult.emit(this.data);
    } 
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}
